<template>
   <div>
      <v-card v-if="(form.membertype !== 'HON') && (form.membertype !== 'FEL')">
         <v-card-title>Payment</v-card-title>
         <v-card-subtitle>
            <p>You can choose to pay using ToyyibPay payment gateway when online payment is enabled. This will take you to the secure online payment process.</p>
            <p>If you have already paid using other methods, you can register your payment receipt by clicking on the 'Register Receipt'
            button and attach your receipt for Secretariat approval. Your membership will only be marked as paid after the receipt is approved.</p>
         </v-card-subtitle>
         <v-card-text>
            <v-simple-table dense>
               <template v-slot:default>
                  <thead>
                     <tr class="cyan darken-2">
                        <th class="text-left"><span class="text-white">Payment Description</span></th>
                        <th class="text-left"><span class="text-white">Payment Date</span></th>
                        <th class="text-left"><span class="text-white">Amount</span></th>
                        <th class="text-left"><span class="text-white">Transaction No.</span></th>
                        <th class="text-left"><span class="text-white">Status</span></th>
                        <th class="text-left"><span class="text-white">Receipt</span></th>
                     </tr>
                  </thead>
                  <tbody v-if="(payments.length > 0)">
                     <tr class="cyan lighten-3"
                        v-for="item in payments"
                        :key="item.id"
                     >
                        <td>{{ item.description }}</td>
                        <td>{{ formatDate(item.paymentdate) }}</td>
                        <td>RM {{ Number(item.amount).toFixed(2) }}</td>
                        <td>{{ item.trxnid }}</td>
                        <td>{{ statusLabel(item.trxnstatus) }}</td>
                        <td>
                           <a v-if="item.document && item.documentpath && item.documentpath !== 'renewal-ref'" :href="'/' + item.documentpath + '/' + item.document" target="NEW">{{ item.document }}</a>
                           <a v-else-if="item.tabletype === 'renewals' && item.trxnstatus === '01' && item.trxnid" :href="'https://toyyibpay.com/' + item.trxnid" target="_blank" rel="noopener" class="receipt-ref-link">
                              <v-icon small color="primary">mdi-receipt</v-icon>
                              View Receipt
                           </a>
                           <span v-else-if="item.trxnstatus === '01' && item.tabletype === 'renewals'" class="grey--text">Paid via ToyyibPay</span>
                           <span v-else>-</span>
                        </td>
                     </tr>
                  </tbody>
                  <tbody v-if="(payments.length === 0)">
                     <tr class="cyan lighten-3">
                        <td colspan="6" class="text-center">No data</td>
                     </tr>
                  </tbody>
               </template>
            </v-simple-table>
         </v-card-text>
         <v-card-actions>
            <div v-if="!haspaid">
               <!-- <v-btn color="primary" @click="dopayment('toyyibpay')" :disabled="submitting"> -->
               <v-btn color="primary" @click="dopayment('toyyibpay')" disabled>
                  Pay with ToyyibPay
               </v-btn>
               <v-btn color="primary" @click="dopayment('manual')" :disabled="submitting || hasPendingReceipt">
                  Register Receipt
               </v-btn>
               <v-alert v-if="hasPendingReceipt" dense text type="info" class="mt-3 mb-0">
                  Your receipt has been submitted and is waiting for admin approval.
               </v-alert>
               <v-dialog v-model="dlgregreceipt" max-width="600px">
                  <v-card>
                     <v-card-title>Register Receipt</v-card-title>
                     <v-card-text>
                        <v-form lazy-validation v-model="formvalid">
                           <v-text-field label="Payment Description" v-model="form.description" readonly dense></v-text-field>
                           <v-select label="Member Type" v-model="form.membertype" :items="membertypes"
                              item-text="description"
                              item-value="membertype"
                              readonly
                              dense
                           ></v-select>
                           <v-text-field label="Amount in RM" v-model="form.amount" readonly dense></v-text-field>
                           <v-text-field
                              label="Receipt / Bank Reference (optional)"
                              v-model="form.trxnid"
                              dense
                              hint="Leave blank if there is no reference number. The system will generate one."
                              persistent-hint
                           ></v-text-field>
                           <v-file-input label="Attach Receipt" accept=".jpg, .png, .pdf" v-model="form.document" show-size dense required :rules="fileRules"></v-file-input>
                        </v-form>
                     </v-card-text>
                     <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="registerreceipt" :disabled="submitting || !formvalid">Register</v-btn>
                        <v-btn color="primary" @click="dlgregreceipt = false">Cancel</v-btn>
                     </v-card-actions>
                  </v-card>
               </v-dialog>
            </div>
            <div v-else-if="haspaid">
               Thank you for the payment
            </div>
         </v-card-actions>
      </v-card>
      <br>
      <v-divider inset></v-divider>
      <v-card>
         <v-card-title>Entrance and Subscription Fees</v-card-title>
         <v-card-subtitle>
            <p>Subscription fees shall be based on the different classes of membership as follows</p>
         </v-card-subtitle>
         <v-card-text>
            <v-simple-table dense>
               <template v-slot:default>
                  <thead>
                     <tr class="grey darken-2">
                        <th class="text-left" width="20"><span class="text-white">No.</span></th>
                        <th class="text-left"><span class="text-white">Classes of Membership</span></th>
                        <th class="text-left" width="150"><span class="text-white">Entrance Fees</span></th>
                        <th class="text-left" width="200"><span class="text-white">Subscription Fees (Annual)</span></th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr class="grey lighten-3"
                        v-for="item in membertypes"
                        :key="item.no"
                     >
                        <td>{{ item.no }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.entfee }}</td>
                        <td>{{ item.subsfee }}</td>
                     </tr>
                  </tbody>
               </template>
            </v-simple-table>
         </v-card-text>
      </v-card>
   </div>
</template>

<script>
const axios = require('axios')

export default {
   name: "TablePayment",

   data() {
      return {
         user: Object,
         membership: Object,
         userid: 0,
         payments: [],
         haspaid: false,
         hasPendingReceipt: false,
         submitting: false,
         formvalid: false,
         dlgregreceipt: false,
         form: {
            description: "Entrance Fee + Subscription Fee",
            membertype: "",
            paymentdate: "",
            amount: 0.00,
            trxnid: "",
            document: null
         },
         membertypes: [
            { no: 1, membertype: "HON", description: "Honorary Fellow", efamount: 0.00, entfee: "None", subsfee: "None" },
            { no: 2, membertype: "FEL", description: "Fellow", efamount: 200.00, entfee: "None", subsfee: "RM 200.00" },
            { no: 3, membertype: "COR", description: "Corporate", efamount: 300.00, entfee: "RM 100.00", subsfee: "RM 200.00" },
            { no: 4, membertype: "GRA", description: "Graduate", efamount: 150.00, entfee: "RM 50.00", subsfee: "RM 100.00" },
            { no: 5, membertype: "STU", description: "Student", efamount: 30.00, entfee: "RM 30.00", subsfee: "None" },
            { no: 6, membertype: "ASC", description: "Associate", efamount: 200.00, entfee: "RM 100.00", subsfee: "RM 100.00" }
         ],
         trxnRules: [],
         fileRules: [
            v => (v !== null) || "Must attach your receipt in PDF or image format"
         ],
         polling: null,
      }
   },

   mounted: function () {
      this.user = this.$page.user
      this.$emit('PaymentMounted')
   },

   beforeDestroy: function () {
	   clearInterval(this.polling)
   },

   methods: {
      setuserid(pUserID) {
         this.userid = pUserID
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            this.loadmemberinfo()
            this.loadpaymentinfo()
         })
      },

      formatDate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY @ h:mm:ss A')
      },

      statusLabel(e) {
         if (e === '01') return 'Approved / Paid'
         if (e === '00') return 'Pending admin approval'
         if (e === '02') return 'Payment pending'
         if (e === '03') return 'Rejected / Failed'
         return e || '-'
      },

      loadmemberinfo() {
         if (this.user.usertype === 'members') {
            var url = '/member/info/' + this.userid
            axios.get(url)
            .then((resp) => {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.membership = rtn.data
                  this.form.membertype = this.membership.membertype
                  this.setamount(this.form.membertype)
               }
            })
         }
      },

      loadpaymentinfo() {
         axios.post('/member/payment/list', {
            userid: this.userid,
            paymenttype: 'EFSF'
         })
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.payments = rtn.data
                  if (this.payments.some(item => item.trxnstatus === '01')) {
                     this.haspaid = true
                     this.hasPendingReceipt = false
                     this.$emit('PaymentCompleted')
                  } else {
                     this.haspaid = false
                     this.hasPendingReceipt = this.payments.some(item => item.trxnstatus === '00' || item.trxnstatus === '02')
                  }
               } else {
                  this.payments = []
                  this.haspaid = false
                  this.hasPendingReceipt = false
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      setamount(e) {
         var rtntype = this.membertypes.find(obj => {
            return obj.membertype === e
         })
         this.form.amount = rtntype.efamount
      },

      dopayment(e) {
         if (e === 'manual') {
            this.dlgregreceipt = true
            return
         }
         if (e === 'toyyibpay') {
            this.toyyibpay()
            return
         }
      },

      toyyibpay() {
         // generate trxn id
         var datenow = this.$moment()
         this.form.paymentdate = datenow.format('YYYY-MM-DDTHH:mm:ss')
         this.setamount(this.form.membertype)

         var data = {
            stringvalue: this.user.email + ';' + datenow.format('YYYYMMDDHHmmss')
         }

         this.submitting = true
         // axios.post('/member/payment/genmd5', data)
         // .then((resp) => {
         //    if (typeof resp.data === 'string') {
         //       var strval = String(resp.data)
         //       if (strval.startsWith("OK:")) {
         //          this.form.trxnid = strval.substring(4)
         //          this.toyyibpay_regtrxn()
         //       }
         //    }
         // })
      },

      toyyibpay_regtrxn() {
         var targetpath = "/member/payment/register"

         var data = {
            userid: this.userid,
            description: this.form.description,
            membertype: this.form.membertype,
            paymenttype: 'EFSF', // Entrance Fee + Subsciption Fee
            amount: this.form.amount,
            trxnid: this.form.trxnid,
            paymentdate: this.form.paymentdate,
            trxnstatus: '100'
         }

         this.submitting = true
         // axios.post(targetpath, data)
         // .then((resp) => {
         //    if (resp.data === 'OK') {
         //       this.toyyibpay_paygate()
         //    }
         // })
         // .catch((error) => {
         //    console.log('ERROR: toyyibpay_regtrxn')
         //    console.log(error)
         // })
      },

      toyyibpay_paygate() {
         // activate payment gate process
         // var payurl = ""
         // window.open(payurl)

         // poll for paygate response
         // this.polling = setInterval(() => {
         //    axios.post('/member/payment/trxn/status', {
         //       trxnid: this.form.trxnid
         //    })
         //    .then((resp) => {
         //       if (resp.data) {
         //          if (resp.data.message === 'OK') {
         //             console.log(resp.data.trxnstatus)
         //          } else {
         //             console.log(resp.data.message)
         //             console.log(resp.data.error)
         //          }
         //       }
         //    })
		   // }, 5000)
      },

      sethaspaid() {
         var targetPath = '/member/payment/haspaid'
         var data = {
            userid: this.userid
         }
         axios.post(targetPath, data)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status !== 'OK') {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      registerreceipt() {
         var targetpath = "/member/payment/register"

         var data = new FormData()
         data.append('userid', this.userid)
         data.append('description', this.form.description)
         data.append('membertype', this.form.membertype)
         data.append('paymenttype', 'EFSF') // Entrance Fee + Subscription Fee
         data.append('amount', this.form.amount)
         if (this.form.trxnid) {
            data.append('trxnid', this.form.trxnid)
         }
         if (this.form.document) {
            data.append('document', this.form.document)
         }

         this.submitting = true
         axios.post(targetpath, data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            if (resp.data) {
               this.submitting = false
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
                  this.dlgregreceipt = false
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })

      }
   }

}
</script>
